{
  "page": {
    "live": "LIVE",
    "liveTooltip": "Receiving live position updates",
    "liveUnavailable": "Live updates unavailable"
  },
  "map": {
    "silence": {
      "seconds": "{{value}} sec",
      "minutes": "{{value}} min",
      "hours": "{{value}} h",
      "days": "{{value}} d"
    },
    "stoppageCodes": {
      "standby": "SB",
      "preventiveMaintenance": "PM",
      "operatingDelay": "OD",
      "nonOperatingDelay": "NOD",
      "maintenanceDown": "MD",
      "unclassified": "UC",
      "down": "DOWN"
    },
    "spriteFailed": "Equipment icons could not be loaded - showing plain position markers.",
    "legend": {
      "upCode": "Up",
      "working": "Working",
      "offCode": "Off",
      "offlineAfter": "Offline - nothing heard for over {{duration}}, shown at its last known position",
      "offline": "Offline - shown at its last known position"
    },
    "loadFailed": "Machine positions could not be loaded.",
    "noPositionsYet": "No plant has reported a position yet.",
    "layers": {
      "sitePlan": "Site plan",
      "haulRoads": "Haul roads",
      "geofences": "Geofences",
      "blastPatterns": "Blast patterns",
      "digBlocks": "Dig blocks",
      "blasting": "Misfires, exclusion zones and monitors"
    },
    "noPositionsTitle": "No machine positions",
    "popup": {
      "stopped": "Stopped",
      "moving": "Moving",
      "speed": "{{speed}} km/h",
      "heading": "heading {{heading}}",
      "unknownLocation": "Unknown location",
      "offlineFor": "Offline - no report for {{duration}}",
      "movingWhileDown": "Moving while marked down - the stoppage may need closing"
    },
    "positionsLoadFailed": "Failed to load machine positions."
  },
  "equipment": {
    "haulTruck": "Production truck",
    "tenWheelTruck": "10-wheel truck",
    "loader": "Loader",
    "excavator": "Excavator",
    "drillRig": "Drill rig",
    "dozer": "Dozer",
    "grader": "Grader",
    "breaker": "Breaker",
    "fireTruck": "Fire truck",
    "waterTruck": "Water truck"
  },
  "blastPatternStatus": {
    "digging": "Digging"
  },
  "digBlock": {
    "flitch": "Flitch {{flitch}}"
  },
  "drillBlast": {
    "reading": "{{value}} {{unit}}",
    "readingWithLimit": "{{value}} {{unit}} (limit {{limit}} {{unit}})",
    "noReadings": "No readings yet",
    "lastReading": "Last reading {{when}}",
    "ppv": "PPV {{reading}}",
    "airblast": "Airblast {{reading}}",
    "percentOfLimit": "{{percent}}% of its limit",
    "exclusionZone": "{{pattern}} fires at {{time}} · exclusion zone {{radius}} m",
    "sentry": "Sentry",
    "hole": "{{pattern}} hole {{hole}} · {{status}}",
    "misfire": "Open misfire · {{pattern}} · found {{when}}",
    "misfireAtHole": "Open misfire · {{pattern}} hole {{hole}} · found {{when}}",
    "misfireNoPosition": "hole position not recorded, shown at the pattern's middle"
  },
  "geofence": {
    "circle": "{{name}} - {{radius}} m radius",
    "buffer": "+{{buffer}} m buffer"
  },
  "geofenceEditor": {
    "heading": "Geofence - {{name}}",
    "introPolygonOnly": "Draw a polygon on the map, or paste one below. Clearing it removes the geofence.",
    "intro": "Draw a polygon on the map, or paste one below. A polygon is used in preference to the circle, and saving it sets the centre and radius to enclose it; clear it to set a centre and radius by hand.",
    "centreLatitude": "Centre latitude",
    "centreLongitude": "Centre longitude",
    "radius": "Radius (m)",
    "accuracyBuffer": "Accuracy buffer (m)",
    "polygon": "Polygon - GeoJSON, WKT, or one \"latitude, longitude\" per line",
    "corners_one": "{{count}} corner",
    "corners_other": "{{count}} corners",
    "measurements": "{{area}} m², {{perimeter}} m perimeter",
    "replacesCircle": "the polygon will be used instead of the circle, and the centre and radius will be set from it.",
    "noPolygonSet": "No polygon set.",
    "noPolygonUseCircle": "No polygon; the centre and radius will be used.",
    "saving": "Saving...",
    "save": "Save geofence"
  },
  "geofencePolygon": {
    "noRing": "That GeoJSON has no coordinate ring.",
    "unreadable": "Could not read that as GeoJSON, WKT or latitude/longitude lines.",
    "notNumbers": "Some coordinates were not numbers.",
    "tooFewCorners": "A geofence needs at least 3 corners; that has {{found}}.",
    "offGlobe": "{{latitude}}, {{longitude}} is off the globe. If it looks inside out, the pairs may be longitude-first."
  },
  "deviceAccuracyTier": {
    "standardOption": "Standard - a normal fleet GPS unit",
    "rtkOption": "RTK - survey-grade, centimetre accuracy",
    "aftermarketOption": "Aftermarket - a cheap retrofitted tracker",
    "standard": "Standard",
    "rtk": "RTK",
    "aftermarket": "Aftermarket"
  }
}
